import React, { useContext } from 'react'
import { CashflowEventsContext } from './context'
import { OverviewScreen } from './Screens/Overview/OverviewScreen'
import { EventTypeScreen } from './Screens/EventType/EventTypeScreen'
import { EventFormScreen } from './Screens/EventForm/EventFormScreen'

export const CashflowEventsScreens = (props) => {
  const { state } = useContext(CashflowEventsContext)
  const { screen } = state

  return (
    {
      index: () => <OverviewScreen />,
      eventType: () => <EventTypeScreen />,
      eventForm: () => <EventFormScreen />

    }[screen || 'index']()
  )
}
